import { defaultFormatOptions, defaultMonthOptions, defaultRenderOptions } from './_defaults';
var BsDatepickerState = (function () {
    function BsDatepickerState() {
    }
    return BsDatepickerState;
}());
export { BsDatepickerState };
export var initialDatepickerState = {
    viewDate: new Date(),
    selectedRange: [],
    monthViewOptions: defaultMonthOptions,
    formatOptions: defaultFormatOptions,
    renderOptions: defaultRenderOptions
};
//# sourceMappingURL=bs-datepicker.state.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/reducer/bs-datepicker.state.js
// module id = 483
// module chunks = 103